import type { EditorView } from "@codemirror/view";

export function resolveHeight(value: number | string | undefined): string {
  if (typeof value === "number" && Number.isFinite(value)) {
    return `${value}px`;
  }
  if (typeof value === "string" && value.trim()) {
    return value;
  }
  return "280px";
}

function replaceSelection(
  view: EditorView,
  nextValue: string,
  selection: { from: number; to: number; anchor: number; head: number },
) {
  view.dispatch({
    changes: { from: selection.from, to: selection.to, insert: nextValue },
    selection: { anchor: selection.anchor, head: selection.head },
    scrollIntoView: true,
  });
  view.focus();
}

export function wrapSelection(
  view: EditorView,
  prefix: string,
  suffix: string,
  placeholder: string,
) {
  const selection = view.state.selection.main;
  const selectedText = view.state.doc.sliceString(selection.from, selection.to);
  const content = selectedText || placeholder;
  const nextValue = `${prefix}${content}${suffix}`;
  const anchor = selection.from + prefix.length;
  replaceSelection(view, nextValue, {
    from: selection.from,
    to: selection.to,
    anchor,
    head: anchor + content.length,
  });
}

export function prefixLines(
  view: EditorView,
  prefixBuilder: (index: number) => string,
  placeholder: string,
) {
  const selection = view.state.selection.main;
  const selectedText = view.state.doc.sliceString(selection.from, selection.to);
  const content = selectedText || placeholder;
  const lines = content.split("\n");
  const nextValue = lines.map((line, index) => `${prefixBuilder(index)}${line}`).join("\n");
  replaceSelection(view, nextValue, {
    from: selection.from,
    to: selection.to,
    anchor: selection.from,
    head: selection.from + nextValue.length,
  });
}

export function insertCodeFence(view: EditorView) {
  const selection = view.state.selection.main;
  const selectedText = view.state.doc.sliceString(selection.from, selection.to);
  const content = selectedText || "code block";
  const nextValue = `\`\`\`\n${content}\n\`\`\``;
  replaceSelection(view, nextValue, {
    from: selection.from,
    to: selection.to,
    anchor: selection.from + 4,
    head: selection.from + 4 + content.length,
  });
}
